import { BehaviorSubject } from 'rxjs';

// const subjectLimitations = new BehaviorSubject([]);
const subjectLimitationsFetched = new BehaviorSubject(false);

const LimitationsFetched = {
  update: fetched => {
    subjectLimitationsFetched.next(fetched);
  },
};

const OrderLimitationsStore = {
  subject: new BehaviorSubject(),
  update: orderLimitations => {
    OrderLimitationsStore.subject.next(orderLimitations);
    LimitationsFetched.update(true);
  },
  subscribe: setState => OrderLimitationsStore.subject.subscribe(setState),
  getValue: () => OrderLimitationsStore.subject.value,
  isFetched: () => subjectLimitationsFetched.value,
};

export default OrderLimitationsStore;
